<template>
  <div>
    
    <div id="preview">
      <img :src="results['logofile']" />
    </div>
    
    <section>

      <h2> General Configuration </h2>
    
      <hr/>

      <b-container class="bv-example-row">

        <b-row>
  
          <b-col cols="8">

            <b-form>

              <label><strong>Tax Jurisdiction</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.tax_code.$error }">  
                <b-form-select 
                  id="taxcodeinput"
                  name="taxcodeinput"
                  v-model="tax_code" 
                  :state="validateState('tax_code')"
                  aria-describedby="taxcode-live-feedback"
                  :disabled="selectstatus"
                >
                <option v-for='taxoption in taxoptions' v-bind:key='taxoption.Id' v-bind:value='taxoption.Id'>{{ taxoption.Name }}</option>
                </b-form-select>
                <b-form-invalid-feedback
                  id="taxcode-live-feedback"
                >Please select a tax jurisdiction.</b-form-invalid-feedback>
              </b-input-group>

              <div class="form-check mt-4">
                <input class="form-check-input" type="checkbox" v-model.trim="status" v-on:click="csichecked($event)" name="checkbox-csi" value="checkbox-csi" id="checkbox-csi">
                <label class="form-check-label" for="flexCheckDefault1">
                Check this box if you have a CSI (Compliance Solutions Inc) access code.
                </label>
              </div>

              <div v-if="selectstatus">
                <label class="mt-2"><strong>Compliance Access Code</strong></label>
                <b-input-group v-bind:class="{ 'has-error': $v.compliance_access_code.$error }">
                  <b-form-input
                    id="accesscodeinput"
                    name="accesscodeinput"
                    v-model.trim="compliance_access_code" @input="$v.compliance_access_code.$touch()"
                    :state="validateState('compliance_access_code')"
                    aria-describedby="accesscode-live-feedback"
                  ></b-form-input>
                <b-form-invalid-feedback
                  id="accesscode-live-feedback"
                >Please enter a valid compliance access code.</b-form-invalid-feedback>
                </b-input-group>
              </div>

            </b-form>

          </b-col>

          <b-col cols="4">
            <b-img :src="require('./assets/images/slide-07.png')" fluid alt="smartbox smartbilling"></b-img>
          </b-col>
      
        </b-row>
  
      </b-container>
  
    </section>

  </div>

</template>

<script>
const { required, email, minLength, maxLength } = require('vuelidate/lib/validators')

export default {
  name: 'StepConfigure',
  props: ['results'],  
  data() {
    return {
      tax_code: '',
      compliance_access_code: null,
      status: '',
      selectstatus: false,
      taxoptions: [
        { 'Id': '', 'Name': 'Please select a tax jurisdiction' },
        { 'Id': 'USA', 'Name': 'USA' },
        { 'Id': 'Canada', 'Name': 'Canada' }
      ]
    }
  },
  validations: {
    tax_code: {
      required
    },
    compliance_access_code: {

    },
    form: ['tax_code', 'compliance_access_code']
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid  
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    csichecked(e) {
      if (e.target.checked) { 
        this.tax_code = 'USA'
        this.selectstatus = true
      }
      else {
        this.selectstatus = false
      }
    }
  }  
}
</script>




// WEBPACK FOOTER //
// src/StepConfigure.vue